import React, { useEffect, useState } from "react";
import tw from "twin.macro";

// ========= ICONS =========
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faSquare as uncheckedIcon,
	faCheckSquare as checkedIcon,
} from "@fortawesome/free-regular-svg-icons";

// ========= MAIN =========
const OptIn = ({ text, setState }) => {
	const [optInIsChecked, setChecked] = useState(false);
	useEffect(() => {
		setState(optInIsChecked);
	}, [optInIsChecked]);

	return (
		<div css={tw`py-5 mb-5 px-2 flex items-start`}>
			<input
				name="optIn"
				id="optIn"
				type="checkbox"
				css={tw`hidden`}
				checked={optInIsChecked}
				onChange={(event) => {
					setChecked(event.target.checked);
				}}
			/>
			{optInIsChecked ? (
				<FontAwesomeIcon
					icon={checkedIcon}
					size="lg"
					onClick={() => setChecked(false)}
				/>
			) : (
				<FontAwesomeIcon
					icon={uncheckedIcon}
					size="lg"
					onClick={() => setChecked(true)}
				/>
			)}
			<div
				htmlFor="optIn"
				css={tw`text-xs text-left ml-2`}
				onClick={() => {
					setChecked(!optInIsChecked);
				}}
			>
				{text}
			</div>
		</div>
	);
};

export default OptIn;
